export const ERROR_MESSAGE_TO_FILTER = [
    //https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    'ResizeObserver loop',

    //User ConduitSwitchUltimateV2 Script error
    'Syntax error, unrecognized expression: a[innerHTML=Console&nbsp;Access]',
    '$ is not defined',

    //React Developer Tools Extension
    'React is running in production mode, but dead code elimination has not been applied.'
];


// WEBPACK FOOTER //
// ./src/constants/logging.jsx